import { render, staticRenderFns } from "./RoomsMemberListItemCollapsed.vue?vue&type=template&id=4ef04b84&scoped=true"
import script from "./RoomsMemberListItemCollapsed.vue?vue&type=script&lang=ts"
export * from "./RoomsMemberListItemCollapsed.vue?vue&type=script&lang=ts"
import style0 from "./RoomsMemberListItemCollapsed.vue?vue&type=style&index=0&id=4ef04b84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef04b84",
  null
  
)

export default component.exports